import React, {useState} from 'react';
import {API_ROOT} from '../../../../baseUrls';
import {connect} from 'react-redux';
import {loginWithCookie} from '../../../../state/actions/authActions';
import {useHistory} from 'react-router-dom';
import {
  Typography,
  Box,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  LinearProgress,
} from '@mui/material';

function CurrentMindfile({user, mindfile}) {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const impersonate = mindfileId => () => {
    setIsLoading(true);
    fetch(`${API_ROOT}/mindfiles/${mindfileId}/sudo`, {
      method: 'GET',
      credentials: 'include',
      headers: {'X-CSRF-Token': user.authenticity_token},
    })
    .then(resp => resp.json())
    .then(resp => {
      if (resp.status.toLowerCase() === 'ok') {
        user.authenticity_token = resp.authenticity_token;
        history.push('/explore');
        window.location.reload(false);
      }
    })
    .catch(error => console.error(error))
    .finally(() => setIsLoading);
  }

  return (
    <Container>
      <Box mt={3}>
        <Typography variant='h4'>
          Current Mindfile
        </Typography>
      </Box>
      <Box style={{marginTop: "1rem"}}>
        <Typography><strong>Name:</strong> {mindfile.name}</Typography>
        <Typography><strong>Upload count:</strong> {mindfile.upload_count}</Typography>
        <Typography><strong>Upload size:</strong> {mindfile.upload_size}</Typography>
        <Typography><strong>Created at:</strong> {mindfile.created_at}</Typography>
      </Box>
      <Box mt={3}>
        <Typography variant='h4'>
          Owner
        </Typography>
      </Box>
      <Box style={{marginTop: "1rem"}}>
        <Typography><strong>Username:</strong> {mindfile.owner_username}</Typography>
        <Typography><strong>Email:</strong> {mindfile.owner_email}</Typography>
      </Box>
      <Box mt={3} mb={3}>
        <Typography variant='h4'>
          Actions
        </Typography>
      </Box>
      {isLoading ?
        <Box>
          <h3>Loading</h3>
          <LinearProgress />
        </Box>
        :
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Description</strong></TableCell>
                <TableCell><strong>Action</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{backgroundColor: "#fff"}}>
              <TableRow>
                <TableCell>
                  Send the owner a warning email
                </TableCell>
                <TableCell>
                  <Button variant="outlined">Warn</Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Login as mindfile
                </TableCell>
                <TableCell>
                  <Button variant="outlined">Switch</Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Login as the user who owns this mindfile
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    onClick={impersonate(mindfile.id)}
                  >
                    Impersonate
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Delete this mindfile and, if there is only one user account, send the user a termination email
                </TableCell>
                <TableCell>
                  <Button variant="outlined">Delete</Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      }
    </Container>
  )
}

const mapStateToProps = state => ({
  user: state.auth,
  mindfile: state.mindfile,
})

const mapDispatchToProps = {
  loginWithCookie
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentMindfile);
